import _ from 'lodash';
import { CfsService, CfsModel } from '../../services/index';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'cfs-info',
  templateUrl: 'cfs-info.html'
})
export class CfsInfo {
  @Input() selectedCfs:CfsModel;
  @Output() closeEe: EventEmitter<any> =  new EventEmitter();

  cfs:CfsModel;

  constructor(
    private cfsService: CfsService
  ) {}

  ngOnInit() {
    if(_.isEmpty(this.selectedCfs)) {
      this.cfs =  new CfsModel();
    } else {
      this.cfs = this.selectedCfs;
    }
  }

  close() {
    this.closeEe.emit();
  }

  saveCfs() {
    this.cfsService.postCfs(this.cfs).subscribe(
      resp => {
        console.log(resp);
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/cfs/cfs-info.ts